module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplement-types text-dark"
  }, [_c('div', {
    staticClass: "supplement-types__header"
  }, [_c('h2', [_vm._v("Tillægstyper")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        _vm.isCreateModal = true
      }
    }
  }, [_vm._v("Opret tillægstype")])]), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('div', [_c('Loader')], 1) : _c('table', {
    staticClass: "do-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.supplementTypes.length === 0) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.supplementTypes), function(supplement) {
    return _c('tr', {
      key: supplement.id
    }, [_c('td', [_vm._v(_vm._s(supplement.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.title))]), _vm._v(" "), _c('td', {
      staticClass: "width-50"
    }, [_vm._v(_vm._s(supplement.account) + "\n          "), _c('div', {
      staticClass: "width-50__icon icon__bg-circle icon__bg-circle--danger",
      on: {
        "click": function($event) {
          return _vm.setTheEditSupplement(supplement)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])])
  })], 2)])]), _vm._v(" "), (_vm.isCreateModal) ? _c('CreateSupplementstype', {
    attrs: {
      "isSubmitting": _vm.isSubmitting,
      "theEditSupplementType": _vm.theEditSupplementType
    },
    on: {
      "save": _vm.createSupplementType,
      "update": _vm.updateSupplementType,
      "close": function($event) {
        return _vm.setIsCreateModal(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Kode")]), _vm._v(" "), _c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', {
    staticClass: "width-50"
  }, [_vm._v("Konto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('i', [_vm._v("Ingen tillægstyper oprettet fundet")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5879a86a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/SupplementsTypes.vue
// module id = 1657
// module chunks = 1